import React, { Component } from "react";
import Switch from "react-switch";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class SwitchBtn extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    let prop = this.props.accessData;
    let groupID = this.props.accessID;
    let currRights = prop.allowAccess;

    this.state = {
      accessRights: currRights,
      groupId: groupID,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
    };
  }

  componentWillMount() {
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });
  }

  handleChange(event) {
    let prop = this.props.accessData;
    let currState = this.state.accessRights;

    const groupManagementDB = fire
      .database()
      .ref("GroupManagement")
      .child(this.state.superAdminID)
      .child(auth.currentUser.uid)
      .child(this.state.groupId)
      .child("groupLocks")
      .child(prop.id);

    groupManagementDB.update({
      allowAccess: !currState,
    });

    this.setState({ accessRights: !currState });

    //     customLog(currState);
    // const retractURL =
    //   "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

    // const grantURL =
    //   "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail";

    // registry.once("value").then(async snapshot => {
    //   if (snapshot.exists()) {
    //     const snapshotVal = snapshot.val();
    //     customLog(snapshotVal);
    //     const emailOfSharedUser = snapshotVal.sharedToEmail;
    //     const serialOfLock = snapshotVal.lockSerial;

    //     const dataToSend = {
    //       lockSerial: serialOfLock,
    //       email: emailOfSharedUser,
    //       ownerUid: auth.currentUser.uid
    //     };

    //     if (!currState === false) {
    //       if (!snapshotVal.allowAccess) {
    //         fetch(retractURL, {
    //           method: "POST",
    //           body: JSON.stringify(dataToSend)
    //         });
    //       }
    //     } else if (!currState === true) {
    //       if (snapshotVal.allowAccess) {
    //         fetch(grantURL, {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json"
    //           },
    //           body: JSON.stringify(dataToSend)
    //         });
    //       }
    //     }
    //   }
    // });
  }

  render() {
    return (
      <Switch
        onChange={this.handleChange}
        checked={this.state.accessRights}
        id="normal-switch"
      />
    );
  }
}

export default SwitchBtn;
